import React, { useState, useEffect } from 'react';
import NotLoggedIn from '../../components/NotLoggedIn';
import { isAuthenticated } from '../../utilities';
import EmailVerifiedIcon from '../../assets/images/email-verify.png';
import { useHistory } from 'react-router-dom';

function VerifyEmail() {
  const [isNotLoggedIn, setIsNotLoggedIn] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (isAuthenticated()) {
      setIsNotLoggedIn(false);
      history.push('/profile');
    } else {
      setIsNotLoggedIn(true);
    }
    localStorage.setItem('verifyEmailId', true);
  }, []);

  return isNotLoggedIn ? <NotLoggedIn /> : <div style={{ textAlign: 'center', margin: 100 }}></div>;
}

export default VerifyEmail;
